import { HttpErrorResponse,HttpEvent,HttpHandler,HttpRequest,HttpInterceptor } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError,throwError,Observable, map } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { LoaderService } from './loader.service';
import { Router } from '@angular/router';
import { admin_menu } from '../modules/admin/adminSidenav';
import { menu } from '../interface/menu';

@Injectable({
  providedIn: 'root'
})
export class LoaderInterceptorService implements HttpInterceptor{

  sideNav:any = admin_menu;

  constructor(public _loader:LoaderService, public router:Router) { }
  
  intercept(req: HttpRequest<any>,next: HttpHandler):Observable<HttpEvent<any>>{

    this._loader.isLoading.next(true);
    return next.handle(req).pipe(
      finalize(()=>{      
        this._loader.isLoading.next(false);
      })
    );
  }

}
